import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderChangeUerVolumesTransferInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerMoveWorkOrderChangeUerRemindersGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerMoveWorkOrderChangeUerReminders';

interface IUseUerTransferUerVolumes {
    onSuccess: () => void;
}

export const useUerTransferUerVolumes = (props: IUseUerTransferUerVolumes) => {
    const dispatch = useDispatch();
    const { onSuccess } = props;

    const [uerTransferUerVolumesReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerTransferUerVolumesReset(undefined);
        onSuccess();
    }, [onSuccess, uerTransferUerVolumesReset]);

    const [, uerWorkOrderChangeUerRemaindersStatus, , uerTransferUerVolumesRequest] = useRequest({
        requestId,
        query: uerMoveWorkOrderChangeUerRemindersGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerTransferUerVolumesMakeRequest = useCallback(
        (input: WorkOrderChangeUerVolumesTransferInput) => {
            uerTransferUerVolumesReset(undefined);

            dispatch(uerTransferUerVolumesRequest({ input }));
        },
        [dispatch, uerTransferUerVolumesRequest, uerTransferUerVolumesReset],
    );

    return {
        uerWorkOrderChangeUerRemaindersStatus,
        uerTransferUerVolumesMakeRequest,
    };
};
